import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid"];

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v && !sessionStorage.getItem(`big_${k}`)) sessionStorage.setItem(`big_${k}`, v);
    });
    const ref = document.referrer;
    if (ref && !ref.includes(window.location.hostname) && !sessionStorage.getItem("big_referrer")) {
      sessionStorage.setItem("big_referrer", ref);
    }
  } catch (e) {}
}

export function getAttribution() {
  const read = (k) => {
    try {
      return sessionStorage.getItem(`big_${k}`) || "";
    } catch (e) {
      return "";
    }
  };
  return {
    utmSource: read("utm_source"),
    utmMedium: read("utm_medium"),
    utmCampaign: read("utm_campaign"),
    utmContent: read("utm_content"),
    utmTerm: read("utm_term"),
    gclid: read("gclid"),
    referrer: read("referrer") || (document.referrer && !document.referrer.includes(window.location.hostname) ? document.referrer : ""),
  };
}

export function apiErrorMessage(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length && detail[0]?.msg) return detail.map((d) => d.msg).join(" ");
  return fallback;
}

export async function submitLead(fields) {
  const attribution = getAttribution();
  const payload = {
    ...attribution,
    ...fields,
    pageUrl: window.location.href,
    submittedAt: new Date().toISOString(),
  };
  const res = await axios.post(`${API}/leads`, payload);
  if (typeof window.gtag === "function") {
    window.gtag("event", "generate_lead", {
      form_name: fields.formName || "website-lead-form",
      program_interest: fields.programInterest || "",
      page_location: window.location.href,
      traffic_source: attribution.utmSource || (document.referrer ? "referral" : "direct"),
    });
  }
  return res.data;
}
